export default __webpack_public_path__ + "cc555509ddc95a9049e32474a2876eca.svg";